/* main-page contents list: highlights the heading in view and scrolls smoothly to anchors. */
(function () {
  function init(root) {
    var links = Array.prototype.slice.call(root.querySelectorAll('.nt-mp__toc-link[href^="#"]'));
    if (!links.length || root.dataset.ntTocInit) return;
    root.dataset.ntTocInit = '1';
    var items = links.map(function (link) {
      return { link: link, target: document.getElementById(decodeURIComponent(link.getAttribute('href').slice(1))) };
    }).filter(function (i) { return i.target; });
    var ticking = false;
    function update() {
      ticking = false;
      var y = window.scrollY + 120, active = null;
      items.forEach(function (i) { if (i.target.getBoundingClientRect().top + window.scrollY <= y) active = i; });
      links.forEach(function (l) { l.classList.toggle('is-active', !!active && l === active.link); });
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    items.forEach(function (i) {
      i.link.addEventListener('click', function (e) {
        e.preventDefault();
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        i.target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        if (history.replaceState) history.replaceState(null, '', '#' + i.target.id);
      });
    });
    update();
  }
  function all() { document.querySelectorAll('.nt-mp--toc').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
